export default {
  data() {
    return {
      urlSet: false,
    };
  },
  methods: {
    cleanUrl(urlString) {
      const newString = this.replaceUnicode(urlString);

      this.data.url = newString
        .replace(/[&|\\/\\#,+()$~%.'":*?<>{}!@^[\];±§=_`]/g, '')
        .replace()
        .replace('--', '-')
        .toLowerCase()
        .split(' ')
        .join('-');

      // Remove all trailing '-' characters
      while (this.data.url.charAt(this.data.url.length - 1) === '-') {
        this.data.url = this.data.url.slice(0, -1);
      }

      // Remove all leading '-' characters
      while (this.data.url.charAt(0) === '-') {
        this.data.url = this.data.url.substr(1);
      }
    },

    /**
     * Replaces lookalike characters.
     *
     * @param {*} string
     */
    replaceUnicode(string) {
      return string
        .replace(/[æ]/gm, 'ae')
        .replace(/[аạąäàáąâāåa]/gm, 'a')
        .replace(/[сƈċ]/gm, 'c')
        .replace(/[ԁɗ]/gm, 'd')
        .replace(/[еéëêèęėēẹ]/gm, 'e')
        .replace(/[ġ]/gm, 'g')
        .replace(/[һ]/gm, 'h')
        .replace(/[іíïìîįī]/gm, 'i')
        .replace(/[јʝj́]/gm, 'j')
        .replace(/[κ]/gm, 'k')
        .replace(/[ӏḷ]/gm, 'l')
        .replace(/[ո]/gm, 'n')
        .replace(/[œ]/gm, 'oe')
        .replace(/[оοօȯọỏơóòöøõōôó]/gm, 'o')
        .replace(/[р]/gm, 'p')
        .replace(/[զ]/gm, 'q')
        .replace(/[ʂ]/gm, 's')
        .replace(/[υսüúùûū]/gm, 'u')
        .replace(/[νѵ]/gm, 'v')
        .replace(/[хҳ]/gm, 'x')
        .replace(/[уý]/gm, 'y')
        .replace(/[ʐż]/gm, 'z');
    },

    suggestUrl(input) {
      if (!this.urlSet) {
        this.cleanUrl(input);
      }
    },

    setUrl() {
      this.urlSet = true;
    },
  },
};
